import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const getMuthootFincorp = async (creditapp_uuid) => {
  try {
    const apiLink = `${endpoint}/api/muthootfincorp-intake-fields/${creditapp_uuid}`;
    const response = await axios.get(apiLink);
    return response.data;
  } catch (error) {
    if (error.response.data.success !== "false") {
      return error.response.data;
    } else {
      customToast.error(error.response.data.message);
    }
    throw error;
  }
};

export default getMuthootFincorp;